import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  assetDataProviderFormElement: {
    width: '100%'
  }
}));

export default useStyles;
